export default function WorkshopPage() {
  return (
    <main className="entry-container">
      <header className="entry-header">
        <div className="entry-brand">
          <img
            src="/logo-white.png"
            alt="Calm But Capable"
            className="entry-logo-small"
          />

          <div>
            <div className="entry-brand-name">Calm But Capable</div>
            <div className="entry-brand-subtitle">The Sanctuary</div>
          </div>
        </div>
      </header>

      <section className="entry-card">
        <p className="entry-eyebrow">Free Workshop</p>

        <h1 className="entry-title">One Clear Step</h1>

        <p className="entry-tagline">
          A calm starting point for regaining clarity and moving forward.
        </p>


<section
  style={{
    margin: "2rem auto",
    padding: "1.25rem",
    borderRadius: "14px",
    border: "1px solid rgba(9,145,237,0.55)",
    background:
      "linear-gradient(135deg, rgba(9,145,237,0.18), rgba(255,255,255,0.04))",
    maxWidth: "720px",
    textAlign: "center",
  }}
>
  <h2
    style={{
      marginTop: 0,
      color: "#0991ED",
      fontSize: "1.25rem",
    }}
  >
    Important: Please Check Your Email
  </h2>

  <p>
    To receive full access to the free workshop and companion workbook,
    you'll need to verify your email address.
  </p>

  <p>
    Please check your inbox and, if necessary, your spam or junk folder
    for the verification email.
  </p>

  <p style={{ marginBottom: 0 }}>
    Once your email is verified, we'll send you the link to the full workshop.
  </p>
</section>

        <div
          style={{
            width: "100%",
            maxWidth: "420px",
            margin: "3rem auto 2.5rem auto",
            borderRadius: "12px",
            overflow: "hidden",
          }}
        >
          <iframe
            src="https://player.vimeo.com/video/1197349309?h=fabf80544f"
            title="One Clear Step"
            style={{
              display: "block",
              width: "100%",
              aspectRatio: "16 / 9",
              border: "none",
              borderRadius: "12px",
            }}
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
          />
        </div>
        <p className="entry-subtitle">
          Before you continue, please watch the short video below and take a few
          minutes to read the rest of this page.
        </p>

        <p>
          Over the next few weeks, we want to give you practical ideas,
          exercises and resources designed to help you move forward with greater
          clarity, confidence and sustainable progress.
        </p>

        <p>
          You will shortly receive an email explaining how to access your free
          workshop, downloadable guide and worksheet.
        </p>

        <p>
          The workshop is designed to help you slow the noise down, identify
          what matters next and take one manageable step without trying to solve
          everything at once.
        </p>

       <section className="entry-section">
  <h2 className="entry-section-title">
    Why progress sometimes feels harder than it should
  </h2>

  <p className="entry-subtitle">
    Most people assume they need more motivation, discipline, or effort.
    Often that isn't the real problem.
  </p>

  <p className="entry-subtitle">
    When life becomes busy, it can feel like you're carrying too many 
    things in your head at once. Tasks, responsibilities, decisions, 
    ideas, and unfinished thoughts all compete for your attention.
  </p>

  <p className="entry-subtitle">
    The more attention is pulled in different directions, the harder 
    it becomes to identify what actually matters next.
  </p>
   </section>

   <section className="entry-section">
  <h2 className="entry-section-title">
    The One Clear Step Exercise
  </h2>

  <div className="entry-steps">
    <div className="entry-step">
      <span className="entry-step-number">1</span>
      Write down everything currently competing for your attention.
    </div>

    <div className="entry-step">
      <span className="entry-step-number">2</span>
      Choose the one thing that would make the biggest positive difference if you moved it forward.
    </div>

    <div className="entry-step">
      <span className="entry-step-number">3</span>
      Reduce it until the next action feels clear and manageable.
    </div>

    <div className="entry-step">
      <span className="entry-step-number">4</span>
      Complete that one action before worrying about everything else.
    </div>
  </div>
</section>

<section className="entry-section">
  <h2 className="entry-section-title">
    Remember
  </h2>

  <p className="entry-subtitle">
    Progress is rarely about doing everything.
  </p>

  <p className="entry-subtitle">
    More often it comes from identifying the right next step and moving
    forward consistently.
  </p>

  <p className="entry-subtitle">
    The Sanctuary was created to help people find clarity, reduce mental
    clutter, and make sustainable progress one step at a time.
  </p>
</section>

<section className="entry-section">
  <h2 className="entry-section-title">
    Your Next Step
  </h2>

  <p className="entry-subtitle">
    Before you leave this page, think about one thing you would like to move
    forward this week.
  </p>

  <p className="entry-subtitle">
    Don't choose everything.
  </p>

  <p className="entry-subtitle">
    Choose one thing.
  </p>

  <p className="entry-subtitle">
    Then identify the smallest meaningful action you can take today.
  </p>

  <p className="entry-subtitle">
    Progress becomes easier when attention is focused on one clear step at a time.
  </p>
  
</section>

<section className="entry-section">
  <h2 className="entry-section-title">Continue Your Journey</h2>

  <p className="entry-subtitle">
    This workshop is one part of the wider Sanctuary approach.
  </p>

  <p className="entry-paragraph">
    Over the coming weeks, we want to give you practical ideas, exercises and
    resources that can help you move forward with greater clarity, focus,
    productivity, mood and energy.
  </p>

  <p className="entry-paragraph">
    Each email is designed to provide one useful concept that you can put into
    practice immediately. These are not quick fixes or productivity tricks
    designed to make you work harder. Instead, they focus on helping you make
    sustainable progress without becoming overwhelmed.
  </p>

  <p className="entry-paragraph">Together we'll explore topics such as:</p>

  <ul className="entry-list">
    <li>Taking the first step when you feel stuck</li>
    <li>Reducing mental clutter and distractions</li>
    <li>Protecting your energy</li>
    <li>Building momentum through small wins</li>
    <li>Creating sustainable habits</li>
    <li>Developing a calmer, more capable approach to everyday challenges</li>
  </ul>

  <p className="entry-paragraph">
    We also want to give you additional guides, exercises and support materials
    that you can keep and return to whenever you need them.
  </p>

  <p className="entry-paragraph">
    Everything we share forms part of the wider Sanctuary approach.
  </p>

  <p className="entry-paragraph">
    Whether you're reading an email, completing an exercise, watching a workshop
    or using a guide, each element is designed to help you move forward with
    greater clarity, confidence and sustainable progress.
  </p>

  <p className="entry-paragraph">
    The Sanctuary software brings these elements together into a structured
    system, helping you apply them consistently, stay focused on what matters
    and build sustainable progress over time.
  </p>

  <p className="entry-paragraph">
    <strong>
      Everything we share is designed around a simple belief:
    </strong>
  </p>

  <p className="entry-subtitle">
    Small, consistent steps often create the greatest long-term progress.
  </p>
</section>
</section>
    </main>
  );
}